<template>
  <div class="ds-login-page">
    <div class="login-header">
      <img
        ref="logo"
        v-if="logo"
        class="logo"
        :src="logo | imgFormat"
        :alt="title"
      />
      <div
        v-if="title"
        class="site-name"
      >{{ title }}</div>
    </div>
    <div
      class="login-section"
      :style="{
        'background-image': carouselItem ? '' : 'url(' + backgroundImage + ')',
      }"
    >
      <div class="login-box">
        <el-form @submit.native.prevent>
          <slot>
            <slot name="form">
              <div class="login-box-title single">
                <div
                  v-if="$loginTemplateList.length == 1"
                  class="login-box-normal"
                >
                  <div>{{ $loginTemplateList[0].name }}</div>
                </div>
                <template v-else>
                  <div
                    v-for="item in $loginTemplateList"
                    :key="item.template"
                    class="login-box-normal"
                    :class="{
                      'login-box-active':
                        item.template === loginTemplateActiveTem,
                    }"
                    @click="handleChangeLogin(item.template)"
                  >
                    <div>{{ item.name }}</div>
                  </div>
                </template>
              </div>
              <!-- login tempalte -->
              <components
                :is="loginTemplateActiveTem"
                v-bind="$attrs"
                :isShowCode="isShowCode"
                :codePlaceholder="codePlaceholder"
                :userNamePlaceholder="userNamePlaceholder"
                :passwordPlaceholder="passwordPlaceholder"
                :phonePlaceholder="phonePlaceholder"
                :codeUrl="codeUrl"
                :isForgotPassword="isForgotPassword"
                :loading="loading"
                @updateCodeUrl="updateCodeUrl"
                @toForgotPassword="toForgotPassword"
                ref="loginTemplate"
              ></components>
              <!-- login common -->
              <!-- <div class="login-box-info login-code" v-if="isShowCode">
                <el-input
                  v-model.trim="code"
                  :disabled="loading"
                  type="text"
                  :placeholder="codePlaceholder"
                  size="medium"
                  prefix-icon="iconfont icon-yanzhengma1"
                />
                <img class="img-code" :src="codeUrl" @click="updateCodeUrl" />
              </div>
              <div class="login-box-info login-password" v-if="loginTemplateActiveTem === 'loginUser'">
                <el-checkbox v-model="remember">记住密码</el-checkbox>
                <div class="login-box-forgot-password" v-if="isForgotPassword">
                  <span @click="toForgotPassword">忘记密码?</span>
                </div>
              </div> -->
              <div class="login-box-button">
                <el-button
                  :loading="loading"
                  type="info"
                  native-type="submit"
                  size="small"
                  @click="submit"
                >登 录</el-button>
              </div>
            </slot>
          </slot>
        </el-form>
      </div>
      <el-carousel
        v-if="carouselItem"
        class="login-carousel"
        :interval="carouselInterval"
      >
        <el-carousel-item
          v-for="item in carouselItem"
          :key="item"
        >
          <img :src="item" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="login-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { loginUser, loginQuick } from './loginTemplate'
export default {
  name: 'DsfPlatformLogin',
  components: { loginUser, loginQuick },
  data() {
    return {
      loading: false,
      carouselHeight: 0,
      carouselInterval:
        Number(dsf.config.setting_public_carousel_interval) || 3000,
      // 图片验证码
      codeUrl: '',
      loginTemplateActiveTem: 'loginUser',
      // 登录方式
      loginTemplateList: [
        {
          name: '用户登录',
          template: 'loginUser',
          visible: true,
        },
        {
          name: '快捷登录',
          template: 'loginQuick',
          visible: dsf.config.setting_security_sms_quick_login == 1,
        },
      ],
    }
  },
  props: {
    logo: {
      type: String,
      default() {
        return dsf.config.setting_public_login_logo
      },
    },
    title: {
      type: String,
      default() {
        return dsf.config.setting_public_login_title
      },
    },
    isForgotPassword: {
      type: Boolean,
      default: true,
    },
    isShowCode: {
      type: Boolean,
      default() {
        // 改成后端配置
        return dsf.config.setting_security_login_image_code_verify == 1
      },
    },
    login: {
      type: Function,
      default: null,
    },
    userNamePlaceholder: {
      type: String,
      default: '账户名称',
    },
    passwordPlaceholder: {
      type: String,
      default: '密码',
    },
    phonePlaceholder: {
      type: String,
      default: '请输入手机号码',
    },
    codePlaceholder: {
      type: String,
      default: '请输入验证码',
    },
    // 图片验证码url
    imgCodeUrl: {
      type: String,
      default: '/code/image?t=@[now().getTime()]',
    },
    backgroundImage: {
      type: String,
      default() {
        return (
          dsf.config.setting_public_login_bg ||
          require('../../assets/styles/themes/img/loginBg.png')
        )
      },
    },
    customSetStateIsLogin: {
      type: Function,
      default() {
        return false
      },
    },
  },
  created() {
    if (this.isShowCode) {
      this.updateCodeUrl()
    }
  },
  computed: {
    carouselItem() {
      let picture = dsf.config.setting_public_carousel_picture
      let item = picture != '' && dsf.isDef(picture) && picture.split(',')
      return item && item.map((v) => dsf.url.getWebPath(v))
    },
    $loginTemplateList() {
      return this.loginTemplateList.filter((item) => item.visible)
    },
  },
  methods: {
    toForgotPassword() {
      // location.replace(dsf.config.setting_public_forgot_password_page)
      location.href = dsf.config.setting_public_forgot_password_page
    },
    // 图片验证码
    updateCodeUrl() {
      const keys = { loginUser: 'pc_login', loginQuick: 'quick_code' }
      const imgCodePath = `${this.imgCodeUrl}&key=${
        keys[this.loginTemplateActiveTem]
      }`
      this.codeUrl = dsf.url.getWebPath(this.$replace(imgCodePath))
    },
    submit() {
      dsf.cookies.remove('authorization_token')
      if (!this.login) {
        if (this.$refs.loginTemplate?.validateFiled()) {
          this.loginHandler()
        }
      } else if (dsf.type(this.login) == 'function') {
        let params = {
          ...this.getLoginTemplateFields(),
        }
        this.login(params)
          .then((res) => {
            if (res && res.success && res.state == 20000) {
              this.setStateIsLogin(res)
            }
          })
          .catch((ex) => {
            dsf.warn('登录不成功')
          })
      }
    },
    loginHandler() {
      this.loading = true
      const loginMethods = { loginUser: 'login', loginQuick: 'loginQuick' }
      const loginParams = this.getLoginTemplateFields()
      this.$webAPI[loginMethods[this.loginTemplateActiveTem]]({
        ...loginParams,
        // remember: this.remember,
        // rememberToken: this.remember ? dsf.md5(dsf.md5(this.password)) : "",
        // code: this.code || "good",
      })
        .then(({ data, success, message, state }) => {
          if (success) {
            data.rememberToken
              ? dsf.storage.local.set('rememberToken', {
                [loginParams.userName]: data.rememberToken,
              })
              : dsf.storage.local.remove('rememberToken')
            this.setStateIsLogin(data)
          } else if (state == 20555) {
            this.$refs.loginTemplate?.handleResetPwdCode()
            dsf.layer.message(message, false)
          } else {
            this.updateCodeUrl()
            dsf.layer.message(message, false)
          }
        })
        .catch((err) => {
          this.updateCodeUrl()
          if (err) {
            dsf.layer.message(err.message || '未知错误', false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 储存cookie登录状态
    setStateIsLogin(data) {
      dsf.cookies.set('isLogin', 1)
      let from = this.$route.query.from
      let _form = this.customSetStateIsLogin(data)
      if (from) {
        from = decodeURIComponent(from)
      } else if (_form) {
        from = _form
      } else {
        from = dsf.config.setting_public_login_success_to
      }
      location.replace(from)
    },
    // 获取登录模板的参数信息
    getLoginTemplateFields() {
      return this.$refs.loginTemplate?.getLoginFileds() || {}
    },
    handleChangeLogin(temName) {
      this.loginTemplateActiveTem = temName
      this.$refs.loginTemplate?.handleClearCode()
      this.updateCodeUrl()
    },
  },
}
</script>
